import axios from "@/libs/api.request";
// 获取批量信息
export const getPath = params => {
  return axios.request({
    url: "/authority/node",
    method: "GET",
    params
  });
};
// 获取单个信息
export const getDetails = id => {
  return axios.request({
    url: `/authority/node/${id}`,
    method: "GET"
  });
};
// 删除单个信息
export const del = id => {
  return axios.request({
    url: `/authority/node/${id}`,
    method: "DELETE"
  });
};
// 修改单个信息
export const update = data => {
  return axios.request({
    url: `/authority/node/${data.id}`,
    method: "PUT",
    data
  });
};
// 新增单个信息
export const add = data => {
  return axios.request({
    url: "/authority/node",
    method: "POST",
    data
  });
};

// 添加备注
export const addRemark = data => {
  return axios.request({
    url: `/authority/node/saveRemarks/${data.id}`,
    method: "POST",
    data
  });
};
